/* eslint-disable import/no-anonymous-default-export */
import client from "./Client";

const signIn = (email, password) =>
  client.post(
    "/signin",
    {
      email,
      password,
    }
  );

const twoFactorAuthentication = (email, access_code) =>
  client.post(
    "/authentication/two-factor",
    {
      email,
      access_code,
    }
  );

const forgotPassword = (email) =>
  client.post(
    "/forgot-password",
    { email }
  );

const updatePassword = (email, password, confirmPassword, resetHash) =>
  client.post(
    "/update-password",
    {
      email,
      password,
      confirm_password: confirmPassword,
      password_reset_hash: resetHash,
    }
  );

const resetPassword = (email, password, confirmPassword, resetHash) =>
  client.post(
    "/reset-password",
    {
      email,
      password,
      confirm_password: confirmPassword,
      password_reset_hash: resetHash,
    }
  );

export default {
  signIn,
  twoFactorAuthentication,
  forgotPassword,
  updatePassword,
  resetPassword,
};
